module.exports = __webpack_public_path__ + "static/media/0045.105d7779.svg";